import type { QuestionType } from '@/types';

export const QTYPE_LABELS: Record<QuestionType, string> = {
  multiple_choice: 'Opción múltiple',
  multiple_select: 'Selección múltiple',
  true_false: 'Verdadero/Falso',
  written: 'Respuesta escrita',
};

export const inputCls =
  'w-full rounded-lg border border-input bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus:border-ring focus:outline-none focus:ring-1 focus:ring-ring';
export const btnPrimary =
  'rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 disabled:opacity-50';
export const btnSecondary =
  'rounded-lg border border-border px-4 py-2 text-sm font-medium text-foreground transition-colors hover:bg-accent';
export const labelCls = 'mb-1.5 block text-sm font-medium text-foreground';
